// admin/src/screens/Audit.jsx — the who/when/why trail (append-only; no delete exists). The
// accountability surface: filter by action / admin / target, newest first, the detail JSON
// readable on demand (before/after for a plan or pack edit; the credit movement's numbers).

import React, { useEffect, useState } from 'react';
import { useAdmin } from '../App.jsx';
import { Banner, fmtDateTime, shortId } from '../lib/ui.jsx';

const ACTIONS = ['', 'credits.comp', 'credits.deduct', 'book.draft', 'book.replace_draft', 'book.activate', 'plan.update', 'pack.update'];

export default function Audit() {
  const { api } = useAdmin();
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(null);
  const [f, setF] = useState({ action: '', admin: '', target: '', limit: 100 });

  async function load() {
    setRows(null); setErr(null);
    const p = new URLSearchParams();
    if (f.action) p.set('action', f.action);
    if (f.admin.trim()) p.set('admin', f.admin.trim());
    if (f.target.trim()) p.set('target', f.target.trim());
    p.set('limit', String(f.limit));
    const r = await api.get('admin/audit?' + p.toString());
    // a failed fetch must NOT masquerade as an empty result — the trail is the accountability surface
    if (r.kind === 'ok') setRows(r.body.audit);
    else { setRows([]); setErr(r.error); }
  }
  useEffect(() => { load(); }, [f.action, f.limit]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <h1>Audit trail</h1>
      <div className="row">
        <select value={f.action} onChange={(e) => setF({ ...f, action: e.target.value })}>
          {ACTIONS.map((a) => <option key={a} value={a}>{a || 'all actions'}</option>)}
        </select>
        <input placeholder="admin user id" value={f.admin} onChange={(e) => setF({ ...f, admin: e.target.value })}
          onKeyDown={(e) => e.key === 'Enter' && load()} className="mono" style={{ inlineSize: 240 }} />
        <input placeholder="target user id" value={f.target} onChange={(e) => setF({ ...f, target: e.target.value })}
          onKeyDown={(e) => e.key === 'Enter' && load()} className="mono" style={{ inlineSize: 240 }} />
        <button className="btn tiny" onClick={load}>Apply</button>
        {(f.admin || f.target) && <button className="btn ghost tiny" onClick={() => setF({ ...f, admin: '', target: '' })}>clear ids</button>}
        <span className="spacer" />
        <label className="hint">rows
          <select value={f.limit} onChange={(e) => setF({ ...f, limit: Number(e.target.value) })} style={{ marginInlineStart: 6 }}>
            {[50, 100, 200, 500].map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
        </label>
      </div>
      {err && <Banner kind="err">{err}</Banner>}
      {!rows ? <p className="muted">Loading…</p> : err ? null : rows.length === 0 ? <p className="muted">No audit rows match.</p> : (
        <table>
          <thead><tr><th>id</th><th>action</th><th>admin</th><th>target</th><th>reason</th><th>detail</th><th>at</th></tr></thead>
          <tbody>
            {rows.map((a) => (
              <tr key={a.id}>
                <td className="mono">{a.id}</td>
                <td>{a.action}</td>
                <td className="mono muted" title={a.admin_user_id}>{shortId(a.admin_user_id)}</td>
                <td className="mono muted" title={a.target_user_id || ''}>{a.target_user_id ? shortId(a.target_user_id) : '—'}</td>
                <td>{a.reason || '—'}</td>
                <td style={{ maxInlineSize: 360 }}>
                  {a.detail ? (
                    <details className="j"><summary>view</summary><pre className="j">{JSON.stringify(a.detail, null, 2)}</pre></details>
                  ) : '—'}
                </td>
                <td className="muted">{fmtDateTime(a.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
